import type { FC } from '../../lib/teact/teact'
import React, { useCallback } from '../../lib/teact/teact'

import type { ApiGroupCall } from '../../api/types'

import buildClassName from '../../util/buildClassName'

import Link from '../ui/Link'
import { getActions } from '../../global'

type OwnProps = {
  as?: React.ElementType<React.ComponentProps<'a'>>
  className?: string
  groupCall?: Partial<ApiGroupCall>
  children: React.ReactNode
}

const GroupCallLink: FC<OwnProps> = ({ as, className, groupCall, children }) => {
  const { requestMasterAndJoinGroupCall } = getActions()

  const handleClick = useCallback(() => {
    if (groupCall?.slug) {
      requestMasterAndJoinGroupCall({ slug: groupCall.slug })
    }
  }, [groupCall?.slug])

  if (!groupCall) {
    return children
  }

  return (
    <Link as={as} className={buildClassName('GroupCallLink', className)} onClick={handleClick}>
      {children}
    </Link>
  )
}

export default GroupCallLink
